import { useEffect, useRef, useState } from "react";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import promotionsApi from "../../services/promotionsApi";

const COOKIE_NAME = "promo_seen";

function getCookie(name) {
	return document.cookie
		.split("; ")
		.find((row) => row.startsWith(name + "="))
		?.split("=")[1] ?? null;
}

function setCookie(name, value) {
	document.cookie = `${name}=${value}; path=/; max-age=${60 * 60 * 24 * 365}`;
}

function fingerprint(promos) {
	return promos
		.map((p) => p.id)
		.sort()
		.join(",");
}

const PromoPopup = () => {
	const [promos, setPromos] = useState(null);
	const [visible, setVisible] = useState(false);
	const swiperRef = useRef(null);

	useEffect(() => {
		promotionsApi
			.fetchPromotions()
			.then((res) => {
				const data = Array.isArray(res.data?.data)
					? res.data.data
					: Array.isArray(res.data)
					? res.data
					: [];
				if (data.length === 0) return;
				const fp = fingerprint(data);
				if (getCookie(COOKIE_NAME) !== fp) {
					setPromos(data);
					setVisible(true);
				}
			})
			.catch(() => {});
	}, []);

	useEffect(() => {
		if (!visible || !promos || promos.length === 0) return;
		if (swiperRef.current) {
			swiperRef.current.destroy(true, true);
			swiperRef.current = null;
		}
		swiperRef.current = new Swiper(".promo-swiper", {
			modules: [Navigation, Pagination],
			slidesPerView: 1,
			loop: promos.length > 1,
			pagination: { el: ".promo-swiper .swiper-pagination", clickable: true },
			navigation: {
				nextEl: ".promo-swiper .swiper-button-next",
				prevEl: ".promo-swiper .swiper-button-prev",
			},
		});
		return () => {
			if (swiperRef.current) {
				swiperRef.current.destroy(true, true);
				swiperRef.current = null;
			}
		};
	}, [visible, promos]);

	const close = () => {
		setCookie(COOKIE_NAME, fingerprint(promos));
		setVisible(false);
	};

	if (!visible || !promos) return null;

	return (
		<div className="popup-overlay" onClick={close}>
			<div className="popup-content promo-popup-content" onClick={(e) => e.stopPropagation()}>
				<button className="popup-close" onClick={close}>×</button>

				<div className="promo-swiper swiper">
					<div className="swiper-wrapper">
						{promos.map((promo) => (
							<div key={promo.id} className="swiper-slide promo-slide">
								{promo.image && (
									<img src={promo.image} alt={promo.name} className="promo-image" />
								)}
								<div className="promo-info">
									{promo.name && <p className="promo-name">{promo.name}</p>}
									{(promo.startDate || promo.endDate) && (
										<p className="promo-dates">
											{promo.startDate}
											{promo.startDate && promo.endDate && " – "}
											{promo.endDate}
										</p>
									)}
								</div>
							</div>
						))}
					</div>
					{promos.length > 1 && (
						<>
							<div className="swiper-pagination"></div>
							<div className="swiper-button-prev"></div>
							<div className="swiper-button-next"></div>
						</>
					)}
				</div>
			</div>
		</div>
	);
};

export default PromoPopup;
